/**
 * The per-card attention chip, shared from the board down to each tile (Metrics
 * Layer A). Board computes the one worst chip per flagged card (attentionChip over
 * the needs-attention result) and provides the ref→chip map here; IssueCard reads
 * its own card's chip. Context keeps it off every card's prop list and out of the
 * store — a derived, board-scoped read that costs nothing when a card is clear.
 */
import { createContext, useContext } from 'react';
import type { AttnSeverity, AttnCause } from '../needs-attention';

export type CardChip = { chip: string; severity: AttnSeverity; cause: AttnCause };

export const AttentionChipsContext = createContext<Map<string, CardChip> | null>(null);

/** The card's one attention chip, or null when it is clear. */
export function useAttentionChip(ref: string): CardChip | null {
  return useContext(AttentionChipsContext)?.get(ref) ?? null;
}
